import { makeCall } from '../api.js';


export const search = (article, detailId=false) => {
 let detail = detailId ? `&detailId=${detailId}`: '';
    return makeCall({
        method: 'GET',
        action: `search/?article=${article}${detail}`
    });
};



/** WEBPACK FOOTER **
 ** ./src/logic/api/search.js
 **/